import LegalPage from "./LegalPage";
export default function Funding() {
  return (
    <div data-testid="funding-page"><LegalPage eyebrow="Disclaimer" title="Funding Disclaimer">
      <p>Bounce City University does not guarantee business funding, personal funding, loan approvals, credit approvals, equipment financing, trailer financing, vehicle financing, interest rates or specific funding amounts.</p>
      <p>Funding depends on individual qualifications, credit profile, lender requirements, financial condition, documentation and market conditions.</p>
      <p>Bounce City University is not acting as a lender unless separately disclosed in writing.</p>
    </LegalPage></div>
  );
}
